import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledPage = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--page-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--page-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--page-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px',
      '--page-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  height: 100%;

  width: calc(100vw - (${props => props.$css.$var('--page-bounds-left')} + ${props => props.$css.$var('--page-bounds-right')}));
  min-height: calc(100vh - (${props => props.$css.$var('--page-bounds-top')} + ${props => props.$css.$var('--page-bounds-bottom')}));
  overflow: hidden;
  
  ${ComponentStyles}
`;

StyledPage.propTypes = {
  theme: PropTypes.object
};

export default StyledPage;
